var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-tour", {
        attrs: { name: _vm.name, steps: _vm.steps, options: _vm.options },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    tour.steps[tour.currentStep]
                      ? _c(
                          "v-step",
                          {
                            key: tour.currentStep,
                            attrs: {
                              step: tour.steps[tour.currentStep],
                              "previous-step": tour.previousStep,
                              "next-step": tour.nextStep,
                              stop: tour.stop,
                              skip: tour.skip,
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              labels: tour.labels,
                            },
                          },
                          [
                            [
                              _c(
                                "div",
                                { attrs: { slot: "actions" }, slot: "actions" },
                                [
                                  tour.isFirst
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "v-step__button",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDontShowTourAgain()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "tours.buttons.dontShowAgain"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !tour.isLast
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "v-step__button",
                                          on: { click: tour.stop },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tours.buttons.skipTour")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !tour.isLast
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "v-step__button",
                                          on: { click: tour.nextStep },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tours.buttons.next")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  tour.isLast
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "v-step__button",
                                          on: { click: tour.stop },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tours.buttons.finish")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticStyle: { position: "fixed", bottom: "10px", right: "10px" },
          attrs: {
            color: _vm.darkMode ? "secondary" : "primary",
            fab: "",
            small: "",
          },
          on: {
            click: function ($event) {
              return _vm.onTourClicked()
            },
          },
        },
        [_c("v-icon", [_vm._v("help_outline")])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }